import React from 'react';
import { Box, Typography } from '@mui/material';
import { TooltipProps } from 'recharts';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';

export const CustomTooltip = ({ active, payload, label }: TooltipProps<ValueType, NameType>) => {
  if (active && payload && payload.length) {
    const formattedLabel = `Tenure range: ${label}`;

    return (
      <Box bgcolor="background.paper" border="1px solid" borderColor="border.default" p={1}>
        <Typography variant="subtitle2">{formattedLabel}</Typography>

        {payload.map((entry, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Box key={index}>
            <Typography variant="body2">
              {entry.name}: {`${entry.value}`}
            </Typography>
            <Typography variant="body2">Share of total headcount: {`${entry.payload.employeePercent}%`}</Typography>
          </Box>
        ))}
      </Box>
    );
  }
  return null;
};
